<template>
    <div class="main-page">
        <TopPage :scrollObserve="observScrollPage"></TopPage>
        <h1>Observe</h1>
        <button @click="clickSub()">Click Sub</button>

        <BackToTop :scrollObserv="observBottomPage"></BackToTop>
    </div>
</template>
<script>
import TopPage from "./TopPage.vue";
import BackToTop from "./BackToTop.vue";
import { Observable } from 'rxjs';

export default {
    name: "MainPage",
    components: {
        TopPage,
        BackToTop,
    },
    data: function() {
        return {
            obs: null,
            subList: [],

            observScrollPage: null,
            subScrollPageList: [],
            observBottomPage: null,
            subBottomPageList: [],
        };
    },
    created: function() {
        this.initScrollPage();

        var count = 0;
        this.obs = new Observable((subscriber) => {
            console.log("sub");
            count++;
            subscriber.next(count);
            this.subList.push(subscriber);
        });

        this.obs.subscribe((x) => {
            console.log("get number: " + x);
        });
        this.obs.subscribe((x) => {
            console.log("get number: " + x);
        });
    },
    beforeDestroy: function() {
        window.onscroll = null;
    },
    methods: {
        clickSub: function() {
            console.log("click sub");
            for (var i of this.subList) {
                i.next(100);
            }
        },

        initScrollPage: function() {
            this.observScrollPage = new Observable((subscriber) => {
                this.subScrollPageList.push(subscriber);
            });
            this.observBottomPage = new Observable((subscriber) => {
                this.subBottomPageList.push(subscriber);
            });

            window.onscroll = () => {
                // 100 คือระยะก่อนถึงจุดล่างสุดของ page
                var scrollOffSet = 100;
                var pageHeight = Math.max(
                    window.pageYOffset,
                    document.documentElement.scrollTop,
                    document.body.scrollTop
                );
                var bottomOfWindow =
                    pageHeight + window.innerHeight >
                    document.documentElement.offsetHeight - scrollOffSet;

                this.eventScroll(pageHeight);
                if (bottomOfWindow) {
                    // this.loadMore();
                    this.eventToBottom(true);
                } else {
                    this.eventToBottom(false);
                }
            };
        },
        eventScroll: function(pageHeightPosition) {
            for (var i of this.subScrollPageList) {
                i.next(pageHeightPosition);
            }
        },
        eventToBottom: function(isBottom) {
            for (var i of this.subBottomPageList) {
                i.next(isBottom);
            }
        },
    },
}
</script>
<style lang="scss" scoped>
    .main-page {
        padding-top: 50px;
        min-height: 200vh;
    }
</style>
